import { useEffect, useState } from "react";

const CountdownTimer = ({ seconds = 30, size = 28, stroke = 3, onComplete, primaryColor = true, total = 30, dangerThreshold = 300,
}) => {
    const [timeLeft, setTimeLeft] = useState(seconds);

    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;

    useEffect(() => {
        setTimeLeft(seconds);
    }, [seconds]);

    const progress = timeLeft / total;
    const strokeDashoffset = circumference * (1 - progress);

    const strokeColor = primaryColor
        ? "#DC2020"
        : timeLeft <= dangerThreshold
            ? "#DC2020" // turn red
            : "#2CBA93"; // green
    return (
        <div className="relative flex items-center justify-center">
            <svg width={size} height={size} className="-rotate-90">
                {/* Background */}
                <circle
                    stroke="#374151"
                    fill="transparent"
                    strokeWidth={stroke}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                />

                {/* Progress */}
                <circle
                    stroke={strokeColor}
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    className="transition-all duration-1000 linear"
                />
            </svg>

            {/* Number */}
            {primaryColor ? <span className="absolute text-[10px] text-error-300 font-semibold">
                {timeLeft}
            </span> :
                timeLeft <= dangerThreshold ?
                    <img src='/images/icons/sand_glass_red.svg' alt='Sand Glass' className="absolute" /> : <img src='/images/icons/sand_glass.svg' alt='Sand Glass' className="absolute" />}
        </div>
    );
};

export default CountdownTimer;